// Los stickers de lo que Cumbre va a leer de la web (ADR-2026-10-01-onboarding-v2-cumbre-guia).
// Cada uno salta cuando Cumbre lo nombra en el globo, y trae una muestra viva de lo que es:
// una paleta que rota, un "Aa" que cambia de letra, un globito que tipea.

import { LO_QUE_LEE, type QueLee } from '../../../lib/onboardingMarca/dialogo';

function Muestra({ id }: { id: QueLee }) {
  if (id === 'logo') {
    return (
      <span className="om-muestra om-muestra--logo">
        <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
          <path d="M12 2.5l2.4 7.1 7.1 2.4-7.1 2.4L12 21.5l-2.4-7.1L2.5 12l7.1-2.4z" fill="currentColor" />
        </svg>
      </span>
    );
  }
  if (id === 'colores') {
    return (
      <span className="om-muestra om-muestra--colores">
        <span className="om-punto" />
        <span className="om-punto" />
        <span className="om-punto" />
      </span>
    );
  }
  if (id === 'letra') {
    return (
      <span className="om-muestra om-muestra--letra">
        <span className="om-aa om-aa--serif">Aa</span>
        <span className="om-aa om-aa--sans">Aa</span>
      </span>
    );
  }
  return (
    <span className="om-muestra om-muestra--tono">
      <span className="om-tipea" />
      <span className="om-tipea" />
      <span className="om-tipea" />
    </span>
  );
}

/**
 * Los cuatro lugares están siempre: los que todavía no se nombraron, invisibles. Así el
 * alto no cambia cuando saltan.
 */
export function LoQueLee({ visibles, quietos }: { visibles: ReadonlySet<QueLee>; quietos: boolean }) {
  return (
    <ul className={`om-stickers ${quietos ? 'om-stickers--quietos' : ''}`} aria-label="Lo que Cumbre lee de tu web">
      {LO_QUE_LEE.map((q) => (
        <li key={q.id} className={`om-sticker ${visibles.has(q.id) ? 'is-visible' : ''}`} aria-hidden={!visibles.has(q.id)}>
          <Muestra id={q.id} />
          {q.etiqueta}
        </li>
      ))}
    </ul>
  );
}

export default LoQueLee;
